import { render, staticRenderFns } from "./SolicitarRelatorio.vue?vue&type=template&id=c88cbcc0&scoped=true&lang=pug"
import script from "./SolicitarRelatorio.vue?vue&type=script&lang=js"
export * from "./SolicitarRelatorio.vue?vue&type=script&lang=js"
import style0 from "./SolicitarRelatorio.vue?vue&type=style&index=0&id=c88cbcc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88cbcc0",
  null
  
)

export default component.exports